import { z } from "zod";

export const createResellerSchema = z.object({
	email: z.string().email("Nieprawidłowy adres email"),
	company_name: z.string().min(1, "Nazwa firmy jest wymagana"),
});
export type CreateResellerFormValues = z.infer<typeof createResellerSchema>;
